import { NextSeo } from 'next-seo'

import { SITE_NAME, SITE_URL } from '@bob/config'
import * as url from '@bob/url'

export function Seo() {
  const pageUrl = url.articles()

  return (
    <NextSeo
      title={`${SITE_NAME} | Magazine`}
      description="Un guide pour consommer bien pour la planète et les humains"
      canonical={SITE_URL + pageUrl.path}
      openGraph={{
        title: `${SITE_NAME} | Magazine`,
        description: 'Un guide pour consommer bien pour la planète et les humains',
        url: SITE_URL + pageUrl.path,
        images: [
          {
            alt: 'Bien ou Bien, le magasin où acheter des biens tout simplement bien',
            url: SITE_URL + '/assets/images/bob_og_image.png',
          },
        ],
      }}
      robotsProps={{
        maxImagePreview: 'large',
      }}
    />
  )
}
